import { Component, OnInit } from '@angular/core';
import { CookieService } from 'src/sb-tools/typescript/authentication/cookie.service';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGComponent } from '../Frontend-Inline-SVG-Module/inline-svg.component';

@Component({
    selector: 'sb-cookie-law-banner',
    templateUrl: './cookie-law-banner.component.html',
    styleUrls: ['./cookie-law-banner.component.scss'],
    imports: [TranslateModule, InlineSVGComponent],
})
export class CookieLawBannerComponent implements OnInit {
    cookieLawSeen = true;
    name = 'cookieLawSeen';

    constructor(private cookieService: CookieService) {}

    ngOnInit(): void {
        this.cookieLawSeen = this.checkIsSeen(this.name);
    }

    private checkIsSeen(cookieName: string): boolean {
        const data = this.cookieService.getCookie(cookieName);

        return !!data;
    }

    closeBanner(): void {
        this.cookieService.setCookie(this.name, true);
        this.cookieLawSeen = true;
    }
}
